import { FeatureFlag, MgPrisFeature, OrgUnitType } from '@retail/mgpris/config-types';

interface EnabledProps {
  features: FeatureFlag[];
  name: MgPrisFeature;
  orgUnitType?: OrgUnitType;
  country?: 'NO' | 'SE';
}

export const isFeatureEnabled = ({
  features,
  name,
  orgUnitType,
  country,
}: EnabledProps): boolean => {
  const feature = features.find((f) => f.name === name);
  if (!feature?.enabled) {
    return false;
  }
  const isExcluded = feature.excludedScopes?.some(
    (scope) =>
      (scope.orgUnitType === undefined || scope.orgUnitType === orgUnitType) &&
      (scope.country === undefined || scope.country === country)
  );
  return !isExcluded;
};
